export default {
    edit: 'Szerkesztés',
    location: 'Helyszín + ÁSZF',
    filter: 'Szűrő',
};
